import { TEXT_BODY, TEXT_MUTED } from '../../lib/medievalTheme';
import { getClass } from '../../utils/arena/classes';
import { ALCHEMIST_POTIONS, HUMOURS, potionArt, potionArtMask, potionPotency } from '../../utils/arena/alchemist';
import { t } from '../../localization/t';

const ACCENT = getClass('alchemist').accent;
const GOOD = '#8fd3a4';
const titleOf = (key) => t(ALCHEMIST_POTIONS.find((p) => p.key === key)?.title || key);

// The settled match on the result screen: humours collected, the potions
// that worked (with their credited bonuses), and a drop if one fell.
export default function AlchemistResult({ alchemist }) {
  const { humours = {}, potions = [], dropped = null, bonuses = {} } = alchemist;
  const gained = HUMOURS.filter((h) => humours[h.key] > 0);
  if (!gained.length && !potions.length && !dropped) return null;
  return (
    <div
      className="match-result-plate flex flex-col mb-3 rounded-lg"
      style={{ padding: '0.5cqw 0.75cqw', gap: '0.375cqw', fontSize: '0.75cqw', lineHeight: 1.35 }}
      data-testid="alchemist-result"
    >
      <div className="flex items-center justify-between">
        <span className="arena-heading" style={{ color: ACCENT, fontSize: '0.875cqw' }}>{t('The harvest')}</span>
        {gained.length ? (
          <span className="flex items-center tabular-nums" style={{ gap: '0.75cqw' }}>
            {gained.map((h) => (
              <span key={h.key} className="arena-heading" style={{ color: h.color }}>+{humours[h.key]} {t(h.label)}</span>
            ))}
          </span>
        ) : <span style={{ color: TEXT_MUTED }}>{t('No humours collected.')}</span>}
      </div>
      {potions.map((key) => (
        <div key={key} className="flex items-center" style={{ gap: '0.5cqw', color: TEXT_BODY }}>
          <img src={potionArt(key)} alt="" draggable={false} style={{ width: '1.5cqw', height: '1.5cqw', objectFit: 'contain', maskImage: potionArtMask(key), maskSize: '100% 100%' }} />
          <span>
            {bonuses[key]
              ? t('{potency} Potion of {name}', { potency: t(potionPotency(bonuses[key].potency)?.title || 'Ordinary'), name: titleOf(key) })
              : t('Potion of {name} worked.', { name: titleOf(key) })}
            {Object.entries(bonuses[key]?.bonus || {}).map(([currency, bonus]) => (
              <span key={currency} className="block tabular-nums" data-testid={`potion-bonus-${currency}`}>
                {t({ coins: 'Gold', arcanaShards: 'Arcana', xp: 'Player XP', seasonXp: 'Season XP', ...Object.fromEntries(HUMOURS.map(h => [h.key, h.label])) }[currency] || currency)}
                {': '}{bonuses[key].base[currency]}{' '}
                <span style={{ color: GOOD }}>{t('+{n} potion bonus', { n: bonus })}</span>
                {' = '}{bonuses[key].base[currency] + bonus}
              </span>
            ))}
          </span>
        </div>
      ))}
      {dropped ? (
        <div className="flex items-center" style={{ gap: '0.5cqw', color: GOOD }}>
          <img src={potionArt(dropped)} alt="" draggable={false} style={{ width: '1.5cqw', height: '1.5cqw', objectFit: 'contain', maskImage: potionArtMask(dropped), maskSize: '100% 100%' }} />
          <span>{t('A Potion of {name} was found among the remains.', { name: titleOf(dropped) })}</span>
        </div>
      ) : null}
    </div>
  );
}
